import { makeAutoObservable } from 'mobx';
import qs from 'qs';
import _ from 'lodash';

class ChargifyState {
  chargifyStore;
  countryStore;

  chargifyDirectParameters;
  errors = {};
  submitting = false;
  countries = [];
  regions = [];

  constructor(stores) {
    makeAutoObservable(this, {
      chargifyStore: false,
      countryStore: false
    });

    this.chargifyStore = stores.chargifyStore;
    this.countryStore = stores.countryStore;
  }

  publishEvent(event) {
    window.parent.postMessage({event, source: 'chargify' }, location.origin);
  }

  async loadChargifyParams(callId) {
    this.chargifyDirectParameters = await this.chargifyStore.loadChargifyDirectParameters(callId);
    if (this.chargifyDirectParameters.billingCountry) {
      await this.loadRegions();
    } else {
      await this.selectCanadaByDefault();
    }
  }

  async selectCanadaByDefault() {
    this.chargifyDirectParameters.billingCountry = {
      id: 'CA'
    };
    await this.loadRegions();
  }

  async load() {
    this.countries = await this.countryStore.loadCountries();

    const callId = qs.parse(location.search.replace('?', ''))['call_id'];

    if (callId) {
      await this.loadChargifyParams(callId);
      const {model, errors} = await this.chargifyStore.checkChargifyDirectCallResult(callId);
      _.forOwn(errors, (v, k) => {
        const prefix = _.capitalize(_.startCase(k)) + ' ';
        errors[k] = v.replace(prefix, '');
      });
      this.errors = errors;

      if (model) {
        this.publishEvent('success');
      }
    } else {
      await this.loadChargifyParams(null);
    }
  }

  submitForm() {
    setTimeout(() => {
      this.submitting = true;
    }, 0);
  }

  async loadRegions() {
    this.regions = await this.countryStore.getOrLoadRegions(this.chargifyDirectParameters.billingCountry.id, false);
  }

  async changeCountry(country) {
    this.chargifyDirectParameters.merge({billingCountry: country});
    await this.loadRegions();
  }

  get years() {
    const CURRENT_YEAR = new Date().getFullYear();
    return _.range(CURRENT_YEAR, CURRENT_YEAR + 11).map(i => i.toString());
  }
}

export default ChargifyState;
